import { lazy } from 'react';

// default app page
const Home = lazy(() => import('./default-apps/Home'));
const OurService = lazy(() => import('./default-apps/OurService'));
const Pricing = lazy(() => import('./default-apps/Pricing'));
const TermsCondition = lazy(() => import('./default-apps/TermsCondition'));
const ProcessingCheckout = lazy(() => import('./default-apps/ProcessingCheckout'));
const Appointment = lazy(() => import('./default-apps/Appointment'));
const AboutUs = lazy(() => import('./default-apps/AboutUs'));
const ArticlePage = lazy(() => import('./default-apps/ArticlePage'));
const BlogPost = lazy(() => import('./default-apps/BlogPost'));
const ArticlePost = lazy(() => import('./default-apps/ArticlePost'));

// auth pages
const AdminSignIn = lazy(() => import('./authentications/AdminSignIn'));
const ConfirmEmail = lazy(() => import('./authentications/ConfirmEmail'));
const ForgotPassword = lazy(() => import('./authentications/ForgotPassword'));
const LockAccount = lazy(() => import('./authentications/LockAccount'));
const ResetPassword = lazy(() => import('./authentications/ResetPassword'));
const SignIn = lazy(() => import('./authentications/SignIn'));
const SignOut = lazy(() => import('./authentications/SignOut'));
const SignUp = lazy(() => import('./authentications/SignUp'));
const ForgotPasswordConfirmation = lazy(() => import('./authentications/ForgotPasswordConfirmation'));
const RecoverPasswordFailed = lazy(() => import('./authentications/RecoverPasswordFailed'));
const RecoverPasswordSuccess = lazy(() => import('./authentications/RecoverPasswordSuccess'));
const AuthFailed = lazy(() => import('./authentications/AuthFailed'));
const VerifyCodeSuccess = lazy(() => import('./authentications/VerifyCodeSuccess'));
const Auth2FA = lazy(() => import('./authentications/Auth2FA'));
const ContinueUsingApp = lazy(() => import('./authentications/ContinueUsingApp'));
const LockScreen = lazy(() => import('./authentications/LockScreen'));
const NotFound = lazy(() => import('./authentications/NotFound'));
const AcceptInvitation = lazy(() => import('./authentications/AcceptInvitation'));

// btai chatbot pages
const AIChatbot = lazy(() => import('./btai-chatbots/AIChatbot'));
const CaseDetail = lazy(() => import('./btai-chatbots/CaseDetail'));
const AIChatbotHome = lazy(() => import('./btai-chatbots/AIChatbotHome'));

const LiveChat = lazy(() => import('./btai-chatbots/LiveChat'));
const ProfileSetting = lazy(() => import('./btai-chatbots/ProfileSetting'));
const SupportCase = lazy(() => import('./btai-chatbots/SupportCase'));
const PaymentSuccess = lazy(() => import('./btai-chatbots/PaymentSuccess'));
const PaymentFail = lazy(() => import('./btai-chatbots/PaymentFail'));

// admin page
const UserPlanSubscription = lazy(() => import('./administrator/AIChatbotPage/UserPlanSubscription'));
const ServicePlanManager = lazy(() => import('./administrator/AIChatbotPage/ServicePlanManager'));
const AwsChatFeedbackManager = lazy(() => import('./administrator/AIChatbotPage/AwsChatFeedbackManager'));
const PaymentInformation = lazy(() => import('./administrator/AIChatbotPage/PaymentInformation'));
const UserCardManagement = lazy(() => import('./administrator/AIChatbotPage/UserCardManagement'));
const UserVisitor = lazy(() => import('./administrator/AIChatbotPage/UserVisitor'));
const UserManagementPage = lazy(() => import('./administrator/UserManagement'));

const FileManagementPage = lazy(() => import('./administrator/FileManagement'));
const SystemManagementHub = lazy(() => import('./administrator/SystemManagement/SystemManagementHub'));
const SystemGeneralPage = lazy(() => import('./administrator/SystemManagement/GeneralPage'));
const EmailMessagingPage = lazy(() => import('./administrator/SystemManagement/EmailMessagingPage'));
const DatabaseManagement = lazy(() => import('./administrator/SystemManagement/DatabaseManagement'));
const SystemLogsManagement = lazy(() => import('./administrator/SystemManagement/LogsManagement'));
const AiServicesPage = lazy(() => import('./administrator/SystemManagement/AiServicesPage'));
const ApiMonitoringPage = lazy(() => import('./administrator/SystemManagement/ApiMonitoringPage'));
const ChatbotPage = lazy(() => import('./administrator/AIChatbotPage/ChatbotPage'));
const ChatManagementPage = lazy(() => import('./administrator/AIChatbotPage/ChatManagementPage'));
const SupportTicketPage = lazy(() => import('./administrator/AIChatbotPage/SupportTicketPage'));
const AIChatbotHub = lazy(() => import('./administrator/AIChatbotPage/AIChatbotHub'));
const PaymentManagementPage = lazy(() => import('./administrator/PaymentManagement'));
const MainControlPanel = lazy(() => import('./administrator/MainControlPanel'));
const DashBoard = lazy(() => import('./administrator/DashBoard'));
const FileManager = lazy(() => import('./administrator/FileManager'));

const LandingPageWrapper = lazy(() => import('./administrator/LandingPage'));

const UserRole = lazy(() => import('./administrator/UserManagement/UserRole'));
const UserInformation = lazy(() => import('./administrator/UserManagement/UserInformation'));
const ApplicationParameter = lazy(() => import('./administrator/SystemManagement/ApplicationParameter'));
const Notification = lazy(() => import('./administrator/SystemManagement/Notification'));
const SystemJobs = lazy(() => import('./administrator/SystemManagement/SystemJobs'));
const OpenAIUsage = lazy(() => import('./administrator/SystemManagement/OpenAIUsage'));
const OpenAIPricing = lazy(() => import('./administrator/SystemManagement/OpenAIPricing'));
const MasterDataManagement = lazy(() => import('./administrator/SystemManagement/MasterDataManagement'));
const TrafficAnalytics = lazy(() => import('./administrator/SystemManagement/TrafficAnalytics'));
const SupportCaseAdmin = lazy(() => import('./administrator/AIChatbotPage/SupportCaseAdmin'));
const AwsUserChatManager = lazy(() => import('./administrator/AIChatbotPage/AwsUserChatManager'));
const AwsChatbotTesting = lazy(() => import('./administrator/Template/AwsChatbotTesting'));
const EmailTemplate = lazy(() => import('./administrator/Template/EmailTemplate'));
const NotiInAppTemplate = lazy(() => import('./administrator/Template/NotiInAppTemplate'));
const Schedule = lazy(() => import('./administrator/SystemManagement/Schedule'));
const SupportCaseHistory = lazy(() => import('./administrator/AIChatbotPage/SupportCaseHistory'));
const MailjetManagement = lazy(() => import('./administrator/SystemManagement/MailjetManagement'));
const SmtpManagement = lazy(() => import('./administrator/SystemManagement/SmtpManagement'));
const AssetsImage = lazy(() => import('./administrator/AssetsImage'));
const DataChatbotManagement = lazy(() => import('./administrator/DataChatbotManagement'));
const QdrantSync = lazy(() => import('./administrator/QdrantSync'));

export {
    Home, OurService, Pricing, TermsCondition, ProcessingCheckout, Appointment, AboutUs, ArticlePage, BlogPost, ArticlePost,

    AdminSignIn, ConfirmEmail, ForgotPassword, LockAccount, SignIn, SignOut, ResetPassword, SignUp, ForgotPasswordConfirmation, RecoverPasswordSuccess, RecoverPasswordFailed, AuthFailed,
    VerifyCodeSuccess, Auth2FA, ContinueUsingApp, LockScreen, NotFound, AcceptInvitation,

    AIChatbot, CaseDetail, AIChatbotHome, LiveChat, ProfileSetting, SupportCase, PaymentSuccess, PaymentFail,

    UserPlanSubscription, ServicePlanManager, AwsChatFeedbackManager, PaymentInformation, UserCardManagement, UserVisitor, DashBoard, FileManager, UserRole, UserInformation, UserManagementPage,
    FileManagementPage, SystemManagementHub, SystemGeneralPage, EmailMessagingPage, AiServicesPage, ApiMonitoringPage, ChatbotPage, ChatManagementPage, SupportTicketPage, AIChatbotHub, PaymentManagementPage, LandingPageWrapper, MainControlPanel,
    ApplicationParameter, Notification, SystemJobs, OpenAIUsage, OpenAIPricing, MasterDataManagement, TrafficAnalytics, SupportCaseAdmin, AwsUserChatManager, AwsChatbotTesting, EmailTemplate, NotiInAppTemplate, Schedule, SupportCaseHistory, MailjetManagement, SmtpManagement, AssetsImage,
    DataChatbotManagement, QdrantSync, DatabaseManagement, SystemLogsManagement
}
